import { render } from "./MessageReport.vue?vue&type=template&id=f35118ca&scoped=true"
import script from "./MessageReport.vue?vue&type=script&lang=js"
export * from "./MessageReport.vue?vue&type=script&lang=js"

import "./MessageReport.vue?vue&type=style&index=0&id=f35118ca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f35118ca"]])

export default __exports__